<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("storage_estimation") }}</h4>
                     
                    <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="downloadData()"
                    >
                       <i class="link-icon" data-feather="download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                  </div>


                    <div class="card-body" style="text-align:center;">
                        <b><h3> {{ $t("total_amount") }}   : {{toCurrency(this.totalAmountStorageHeader)}}</h3></b> 
                   </div>
  
                  <div class="card-body">
                    <vue-good-table
                      title="list-billing-storage-estimation-cml"
                      mode="remote"
                      @on-selected-rows-change="selectionChanged"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }"
                      :rows="rows"
                      :columns="columns"
                     
                    >

                        <template slot="column-filter" slot-scope="{ column }">
                        
                            <span v-if="column.filterOptions.customFilter">
    
    
                            <span v-if="column.field =='trxDate'">
    
                                <date-range-picker style="width:100%" @update="receiveDateChange" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="receiveDate" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clearreceiveDateChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                                    <br>
                                </div>
                                </date-range-picker>
    
                            </span>
                            
                            </span>
                            
    
                        </template>
  
                       <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'amount'">
                            {{toCurrency(props.row.amount)}}
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>

                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';
  
  export default {
    name: "CmlStorageEstimationIndex",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        DateRangePicker,
    },
    data() {
      return {
            opens:"center",
            locale:{
                format:"yyyy-mm-dd",
            
            },
            receiveDate: {
                startDate: null,
                endDate: null
            },
            highlighted:{

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },
            maxToasts: 100,
            totalAmountStorageHeader: 0,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            permision_role:[],
            langs: ["id", "en"],
            detailUser: [],
            idTarifMasterHeaders:[],
            detailDivisi: [],
            totalRecords: 0,
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
            columns: [
    
            {
                label: this.$t("customerId"),
                field: "customerId",
                filterOptions: {
                enabled: true, // enable filter for this column
                customFilter: false,
                placeholder: this.$t("customerId"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
    
            {
                label: this.$t("warehouseId_txt"),
                field: "warehouseId",
                filterOptions: {
                enabled: true, // enable filter for this column
                placeholder: this.$t("warehouseId_txt"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
    
            {
                label: this.$t("trxDate"),
                field: "trxDate",
                filterOptions: {
                enabled: true, // enable filter for this column
                customFilter: true,
                placeholder: this.$t("trxDate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
    
            {
                label: this.$t("total_amount"),
                field: "amount",
                filterOptions: {
                enabled: false, // enable filter for this column
                customFilter: false,
                placeholder: this.$t("total_amount"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
                },
            },
    
            ],
            rows: [],
            rowsSelection:[],
            trxFrom:"",
            trxTo:"",
      };
    },
    watch: {},
    methods: {
  
        toCurrency (value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'IDR'
            });
            return formatter.format(value);
        },
        
        receiveDateChange(){

            if(this.receiveDate.startDate && this.receiveDate.endDate){
                this.trxFrom    = this.$moment(String(this.receiveDate.startDate)).format('YYYY-MM-DD');
                this.trxTo      = this.$moment(String(this.receiveDate.endDate)).format('YYYY-MM-DD');
                this.loadItems()
            }

        },

        clearreceiveDateChange(){
            this.receiveDate={
                startDate: null,
                endDate: null
            };
            this.trxFrom    = ""
            this.trxTo      = ""
            this.loadItems()
        },
  
        downloadData() {
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/storage-estimation";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            let trxFrom = this.trxFrom
            let trxTo   = this.trxTo

            return this.$http
            .get(
                baseURI +
                `?sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&warehouseId=${this.serverParams.columnFilters.warehouseId}&trxTo=${trxTo}&trxFrom=${trxFrom}&download=download`,
                {
                responseType: "blob",
                }
            )
            .then((response) => {
            
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });
        },
   
        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/storage-estimation";
            this.isLoading = true;
    

            let trxFrom = this.trxFrom
            let trxTo   = this.trxTo

            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&warehouseId=${this.serverParams.columnFilters.warehouseId}&trxFrom=${trxFrom}&trxTo=${trxTo}`,
                { timeout: 50000 })
            .then((response) => {
                this.isLoading = false;
                this.rows                       = response.data.datas.data;
                this.totalRecords               = response.data.datas.total;
                this.totalAmountStorageHeader   = response.data.totalamountstorageHEADER;
            }).catch((error) => {
                    this.loading();
                    
                      if(error.code == "ECONNABORTED"){
                        this.error(this.$t("check_internet_connection_txt"));
                        
                        }else{
        
                            if (error.response) {
                                if(error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                }else if (error.response.status === 401) {
                                    this.logout();
                                } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                }else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                }else{
                                    this.$router.push('/page-not-found');
                                }
                            }
        
                        }
            });
        },
    
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
    
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
    
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
    
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
    
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
    
        fade(sType) {
            this.isLoading = sType;
        },
    
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },
    
        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.detailUser     = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'StorageEstimationController'){
                rolePermision = permision;
            }
            });
    
            if(!rolePermision.method_read){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
    
       
        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
    },
    events: {},
    created: function () {},
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  .blur-content{
    filter: blur(5px); 
  }
  </style>